module.exports = {
  painter: require('./painter')
};